import { render, staticRenderFns } from "./MordaLentaCard.vue?vue&type=template&id=7c0d9e52&scoped=true"
import script from "./MordaLentaCard.vue?vue&type=script&lang=js"
export * from "./MordaLentaCard.vue?vue&type=script&lang=js"
import style0 from "./MordaLentaCard.vue?vue&type=style&index=0&id=7c0d9e52&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c0d9e52",
  null
  
)

export default component.exports